'use client';

import { FC } from 'react';

import HeroSection from '@/components/common/shops/hero-section';
import ImageTextContainer from '@/components/common/shops/text-image-container';

const AboutUs: FC = () => {
  const heroData = {
    backgroundImage: '/imgs/background.jpg',
    title: 'Hagyomány és elhivatottság több mint három évtizede',
    subtitle:
      'A Benedek Húsüzem egy erdélyi vállalkozás, amely több mint 30 éve készít minőségi hús- és hentesárukat. Történetünk a ’90-es években indult, azzal a céllal, hogy megőrizzük a hagyományos ízeket, miközben modern technológiával és szigorú minőségellenőrzéssel szolgáljuk ki vásárlóinkat.',
  };

  const aboutSections = [
    {
      image: '/imgs/background.jpg',
      title: 'Hagyomány és kiválóság minden termékben',
      description:
        'Minden Benedek termék mögött gondosan válogatott alapanyagok és tapasztalt szakemberek állnak. Kizárólag ellenőrzött forrásból származó, friss húst dolgozunk fel, és a teljes gyártási folyamat során kiemelt figyelmet fordítunk a higiéniai és minőségbiztosítási előírásokra. Hentes és húskészítményeink hagyományos receptek alapján készülnek, kompromisszumok nélkül – mert hisszük, hogy a valódi minőség ízben és állagban is érezhető.',
    },
    {
      image: '/imgs/background.jpg',
      title: 'Elhivatott emberek a termékek között',
      description:
        'A Benedek sikerének alapja a csapatunk. Tapasztalt kollégáink nap mint nap azon dolgoznak, hogy vásárlóink mindig friss, ízletes és megbízható termékeket kapjanak. Ugyanaz az odafigyelés és szakértelem jellemzi az online rendelések feldolgozását is, mint amit üzleteinkben személyesen tapasztalhat.',
    },
    {
      image: '/imgs/background.jpg',
      title: 'Hagyomány és frissesség közel Önhöz',
      description:
        'Ma már 25 saját üzlettel vagyunk jelen Románia különböző régióiban. Üzleteink célja, hogy vásárlóink helyben is megtapasztalják azt a minőséget és gondoskodást, amely a Benedek márkát jellemzi. Webshopunkkal ezt az élményt országos szinten is elérhetővé tesszük – ugyanazzal a minőséggel, amelyet üzleteinkben megszokott.',
    },
    {
      image: '/imgs/background.jpg',
      title: 'Minőség, amelyben megbízhat',
      description:
        'Legyen szó személyes vásárlásról vagy online rendelésről, célunk változatlan: kiváló minőségű hús- és hentesárukat biztosítani vásárlóink számára.A Benedek Húsüzemnél a hagyomány, a szakértelem és a megbízhatóság kéz a kézben jár – hogy Ön mindig nyugodt szívvel választhassa termékeinket.',
    },
  ];

  return (
    <>
      <HeroSection
        backgroundImage={heroData.backgroundImage}
        title={heroData.title}
        subtitle={heroData.subtitle}
      />
      <div className="container mx-auto px-5 py-8">
        {aboutSections.map((section, index) => (
          <ImageTextContainer
            key={index}
            image={section.image}
            title={section.title}
            description={section.description}
            reverse={index % 2 === 1}
          />
        ))}
      </div>
    </>
  );
};

export default AboutUs;
